import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimerSelectComponent } from './timer-select.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { SelectFormularioModule } from "../select-formulario/select-formulario.module";

@NgModule({
    declarations: [TimerSelectComponent],
    imports: [CommonModule, MatFormFieldModule, ReactiveFormsModule, SelectFormularioModule],
    exports: [TimerSelectComponent]
})
export class TimerSelectModule {}
